<template>
  <app-view title="我的設置">
    <div class="text-chicago leading-none p-2 " v-if="$auth.loggedIn">
      <div class="aspect-video relative">
        <img class="w-full h-full object-fit" src="/imgs/member_card.png" />

        <div class="absolute inset-x-0 bottom-0 text-white px-6 py-4 font-bold z-10">
          <p class="mb-2">編號：{{ myinfo.no }}</p>
          <p class="mb-2">會員：{{ myinfo.name }}</p>
          <p>電話：({{ myinfo.code }}){{ myinfo.tel }}</p>
        </div>
      </div>
    </div>

    <div class="text-chicago leading-none">
      <template v-for="(nav, index) in navs">
        <nav-item
          class="bg-white px-2 mb-0.5"
          :nav="nav"
          v-if="showable(nav)"
          :key="index"
        />
      </template>
    </div>
  </app-view>
</template>

<script>
import { mapActions } from "vuex";

import NavItem from "@/components/me/NavItem.vue";

export default {
  auth: false,
  components: {
    NavItem,
  },
  head() {
    return {
      title: `${process.env.APP_NAME}-我的設置`,
    };
  },
  data() {
    return {
      navs: [
        { text: "關於我們", to: this.go("/about") },
        { text: "退換政策", to: this.go("/teams/policies/refund") },
        {
          text: `${process.env.APP_NAME}網站用戶註冊協議`,
          to: this.go("/teams/policies/service"),
        },
        { text: "私隱政策", to: this.go("/teams/policies/privacy") },
        { text: "購買流程", to: this.go("/procedure") },
        // { text: "GM FUN", to: this.go("/me/gmpay") },
        {
          text: "會員登入",
          to: this.go("/auth/login"),
          guest: true,
        },
        {
          text: "帳號設置",
          to: this.go("/setting"),
          auth: true,
        },
        {
          text: "賬號綁定",
          to: this.go("/bindAccount"),
          auth: true,
        },
        {
          text: "登出",
          click: () => this.logout(),
          type: "button",
          auth: true,
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      empty: "cart/empty",
    }),
    go(line) {
      return this.localePath(line);
    },
    showable(nav) {
      if (nav.guest && this.$auth.loggedIn) return false;
      if (nav.auth && !this.$auth.loggedIn) return false;

      return true;
    },
    logout() {
      if (!confirm("確定要登出會員？")) {
        return;
      }

      this.$auth.logout().then(() => {
        this.empty();
        this.$router.push(this.localePath("/auth/login"));
      });
    },
  },
};
</script>
